(() => {
  const reduceMotion = () => Boolean(window.matchMedia?.('(prefers-reduced-motion: reduce)')?.matches);

  class AnnouncementMarquee extends HTMLElement {
    connectedCallback() {
      this.update = this.update.bind(this);
      this.update();
      this._ro = new ResizeObserver(this.update);
      this._ro.observe(this);
      window.addEventListener('resize', this.update);
    }

    disconnectedCallback() {
      this._ro?.disconnect();
      window.removeEventListener('resize', this.update);
    }

    update() {
      const track = this.querySelector('.announcement-bar__track');
      const group = this.querySelector('.announcement-bar__group:not(.announcement-bar__group--clone)');
      if (!track || !group) return;

      const mobile = Boolean(window.matchMedia('(max-width: 749px)').matches);
      const overflow = group.scrollWidth > this.clientWidth + 8;
      const shouldMove = !reduceMotion() && (mobile || overflow);
      this.classList.toggle('is-marquee', shouldMove);
      const duration = Math.max(16, Math.round(group.scrollWidth / 32));
      track.style.setProperty('--marquee-duration', `${duration}s`);
    }
  }

  if (!customElements.get('announcement-marquee')) {
    customElements.define('announcement-marquee', AnnouncementMarquee);
  }
})();
